
import { type AppDispatch, type RootState } from '../../../store/store';
import { apiFetch, type ApiResult } from './client';

interface LoaderActions<T> {
    start?: () => any;
    success: (payload: T) => any;
    error?: (message: string) => any;
}

export function createLoaderThunk<T>(
    key: string,
    actions: LoaderActions<T>,
    builder: (args?: any) => Promise<ApiResult<T>>,
    { noLoadingFlagKey = 'noLading' } = {}
) {
    return (args?: any) =>
        async (dispatch: AppDispatch, getState: () => RootState) => {

            const noLoading = args?.[noLoadingFlagKey] === true;
            if (!noLoading && (actions.start != null)) dispatch(actions.start());

            const res = await builder(args);
     
            if (res.ok) {
                dispatch(actions.success(res.data));
                return { textNavigate: '', isSuccessful: true, textNotification: ''   ,  
                    data: res.data,
                    response: res.data };
            } else {
                if (actions.error != null) dispatch(actions.error(res.error));
                return { textNavigate: '', isSuccessful: false, textNotification: res.error ?? '' };
            }
        };
}
